/**
 * Formaters to FormData acceptable args by type.
 */
export const formatToJsonArgs = (key, value) => [key, JSON.stringify(value)];
export const formatToImageArgs = (key, value) => [key, value, value.name];
export const formatToPkArgs = (key, value) => [key, value.id];

const mapToOptionById = (data) =>
  Object.keys(data).map((key) => ({
    id: Number(key),
    name: data[key],
  }));

export { mapToOptionById };